import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl, FormControl, ReactiveFormsModule } from '@angular/forms';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'form-builder-pixel-size',
  template: `
    <glxy-form-field>
      <glxy-label>{{ label }}</glxy-label>
      <input type="number" [formControl]="field" matInput />
      <div *ngIf="suffix" glxySuffix class="suffix-text unit-select">
        <select [formControl]="suffix" (change)="unitChanges()">
          <option value="px">px</option>
          <option value="%">%</option>
        </select>
      </div>
      <div *ngIf="!suffix" glxySuffix class="suffix-text">px</div>
      <glxy-error *ngIf="field.invalid">{{ field.errors['size'] }}</glxy-error>
    </glxy-form-field>
  `,
  styles: [
    `
      .unit-select {
        padding: 0 0;
      }

      .unit-select select {
        min-width: 70px;
        padding: 0 20px;
        background-position: right 12px top 50%;
      }
    `,
  ],
  imports: [CommonModule, GalaxyFormFieldModule, ReactiveFormsModule, MatIconModule],
})
export class PixelSizeComponent {
  @Input() label = '';
  @Input() field = new FormControl<number>(0, { nonNullable: true });
  @Input() suffix;

  @Output() unitChanged = new EventEmitter<string>();

  unitChanges() {
    this.unitChanged.emit(this.suffix.value);
  }
}

export function newPixelControl(initial: number, min?: number, max?: number): FormControl<number> {
  return new FormControl<number>(initial, {
    nonNullable: true,
    validators: [
      (control: AbstractControl) => {
        if (!control.value && control.value !== 0) {
          return {
            size: `Must be >= ${min} and <= ${max}.`,
          };
        }
        if (min !== undefined && control.value < min) {
          return {
            size: `Must be >= ${min}.`,
          };
        }
        if (max !== undefined && control.value > max) {
          return {
            size: `Must be <= ${max}.`,
          };
        }
        return null;
      },
    ],
  });
}

export function newPixelUnitControl(initial: string): FormControl<string> {
  return new FormControl<string>(initial, { nonNullable: true });
}
